import React from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import 'src/components/selfServeWorkflows/executionView/execution-view.scss';

export interface SubWorkflowExecutionGroupNodeData {
	workflowName: string;
	childWorkflowId: string;
	childExecutionId: string;
	onToggle?: (data: {
		childWorkflowId: string;
		childWorkflowExecutionId: string;
		workflowName?: string;
	}) => void;
}

export default function SubWorkflowExecutionGroupNode({
	data,
}: NodeProps<SubWorkflowExecutionGroupNodeData>) {
	const handleCollapse = (event: React.MouseEvent) => {
		if (!data.onToggle) return;
		event.stopPropagation();
		data.onToggle({
			childWorkflowId: data.childWorkflowId,
			childWorkflowExecutionId: data.childExecutionId,
			workflowName: data.workflowName,
		});
	};

	return (
		<div className="sub-workflow-exec-group">
			<Handle type="target" position={Position.Top} isConnectable={false} />
			<div className="sub-workflow-exec-group__header">
				<span className="sub-workflow-exec-group__title">
					🧩 {data.workflowName}
				</span>
			</div>
			<button
				type="button"
				className="sub-workflow-exec-group__collapse"
				aria-label="Collapse sub-workflow"
				onClick={handleCollapse}
			>
				⊖
			</button>
			<Handle type="source" position={Position.Bottom} isConnectable={false} />
		</div>
	);
}
